<div class="card" *ngIf="InvoiceTraceability?.CurrentWorkflow || InvoiceTraceability?.CurrentWorkflowPromotion || InvoiceTraceability?.PreviousWorkflows">
  <div class="card-header card-title">Circuits de validation</div>
  <div class="card-body" *ngFor="let previousWorkflow of InvoiceTraceability.PreviousWorkflows  | orderBy:'StartDate':'asc'">
    <div class="row container-name">
      <div class="col-xs-12 col-md-2 label" *ngIf="!previousWorkflow.IsPromotionWorkflow">
        Circuit de validation BAP
      </div>
      <div class="col-xs-12 col-md-2 label" *ngIf="previousWorkflow.IsPromotionWorkflow">
        Circuit de validation promotion
      </div>
      <div class="col-xs-12 col-md-auto item-name">
        {{previousWorkflow.WorkflowName}}
      </div>
    </div>
    <div class="row container-status">
      <div class="col-xs-12 col-md-2 label">
        Statut
      </div>
      <div class="col-xs-12 col-md-auto item-status">
        {{previousWorkflow.IsCompleted ? 'Annulé' : 'Refusé'}}
      </div>
    </div>
    <div class="row container-levels" *ngFor="let workflowStageValidation of previousWorkflow.WorkflowStageValidations  | orderBy:'ValidationLevel':'asc'">
      <div class="col-1 item-level">
        Niveau {{workflowStageValidation.ValidationLevel}}
      </div>
      <div class="col-3 item-user">{{workflowStageValidation.UserName}}</div>
      <div class="col-1" *ngIf="workflowStageValidation.IsValid || workflowStageValidation.IsValidPromotion == 1">
        <span class="material-icons" tooltip="Validé">check</span>
      </div>
      <div class="col-1" *ngIf="workflowStageValidation.IsValidPromotion == 3">
        <span class="material-icons" tooltip="Refusé">not_interested</span>
      </div>
      <div class="col-1" *ngIf="workflowStageValidation.IsValidPromotion == 2">
        <span class="material-icons" tooltip="Refusé pour modification">not_interested</span>
      </div>
      <div class="col-4 item-comment">{{workflowStageValidation.Comment}}</div>
      <div class="col-3 item-valueDate">
        {{workflowStageValidation.ValidationDate | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
    </div>
    <hr />
  </div>
  <div class="card-body" *ngIf="InvoiceTraceability?.CurrentWorkflow">
    <div class="row container-name">
      <div class="col-xs-12 col-md-2 label">
        Circuit de validation BAP
      </div>
      <div class="col-xs-12 col-md-auto item-name">
        {{InvoiceTraceability.CurrentWorkflow.WorkflowName}}
      </div>
    </div>
    <div class="row container-status">
      <div class="col-xs-12 col-md-2 label">
        Statut
      </div>
      <div class="col-xs-12 col-md-auto item-status">
        {{InvoiceTraceability.CurrentWorkflow.IsCompleted || !InvoiceTraceability.CurrentWorkflow.IsActive ? 'Terminé' :
        'En cours'}}
      </div>
    </div>
    <div class="row container-levels" *ngFor="let workflowStageValidation of InvoiceTraceability.CurrentWorkflow.WorkflowStageValidations  | orderBy:'ValidationLevel':'asc'">
      <div class="col-1 item-level">
        Niveau {{workflowStageValidation.ValidationLevel}}
      </div>
      <div class="col-3 item-user">{{workflowStageValidation.UserName}}</div>
      <div class="col-1" *ngIf="workflowStageValidation.IsValid">
        <span class="material-icons" tooltip="Validé">check</span>
      </div>
      <div class="col-1" *ngIf="!workflowStageValidation.IsValid">
        <span class="material-icons" tooltip="Refusé">not_interested</span>
      </div>
      <div class="col-4 item-comment">{{workflowStageValidation.Comment}}</div>
      <div class="col-3 item-valueDate">
        {{workflowStageValidation.ValidationDate | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
    </div>
  </div>
  <div class="card-body" *ngIf="InvoiceTraceability?.CurrentWorkflowPromotion">
    <div class="row container-name">
      <div class="col-xs-12 col-md-2 label">
        Circuit de validation Promotion
      </div>
      <div class="col-xs-12 col-md-auto item-name">
        {{InvoiceTraceability.CurrentWorkflowPromotion.WorkflowName}}
      </div>
    </div>
    <div class="row container-status">
      <div class="col-xs-12 col-md-2 label">
        Statut
      </div>
      <div class="col-xs-12 col-md-auto item-status">
        {{InvoiceTraceability.CurrentWorkflowPromotion.IsCompleted ||
        !InvoiceTraceability.CurrentWorkflowPromotion.IsActive ? 'Terminé' : 'En cours'}}
      </div>
    </div>
    <div class="row container-levels" *ngFor="let workflowStageValidation of InvoiceTraceability.CurrentWorkflowPromotion.WorkflowStageValidations  | orderBy:'ValidationLevel':'asc'">
      <div class="col-1 item-level">
        Niveau {{workflowStageValidation.ValidationLevel}}
      </div>
      <div class="col-3 item-user">{{workflowStageValidation.UserName}}</div>
      <div class="col-1" *ngIf="workflowStageValidation.IsValid">
        <span class="material-icons" tooltip="Validé">check</span>
      </div>
      <div class="col-1" *ngIf="!workflowStageValidation.IsValid">
        <span class="material-icons" tooltip="Refusé">not_interested</span>
      </div>
      <div class="col-4 item-comment">{{workflowStageValidation.Comment}}</div>
      <div class="col-3 item-valueDate">
        {{workflowStageValidation.ValidationDate | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
    </div>
  </div>
</div>
